export const SI_PHONE_MAX = 768;

export const isSuiteInspectionPhone = (width) => {
  const w = width ?? (typeof window !== 'undefined' ? window.innerWidth : 1024);
  return w < SI_PHONE_MAX;
};

export const resolveSuiteInspectionViewMode = (saved, width) => (
  isSuiteInspectionPhone(width) ? 'modal' : (saved || 'inline')
);
